// extracted by mini-css-extract-plugin
export default {"promoCodeCampaignText":"G4ef9f9 G481d88","inputFieldContainer":"Gaafef4"};